import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import AddWidgetIcon from '../../../../../../src/assets/icons/dasboardIcons/add-widget-icon.svg';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { groupableHorizontalChartOptions, groupableVerticalChartOptions, heatMapChartOptions, horizontalChartOptions, pieChartOptions, stringChartOptions, verticalChartOptions } from './WidgetOptions';
import CalendarHeatmap from 'react-calendar-heatmap';
import 'react-calendar-heatmap/dist/styles.css';
import { ClickAwayListener, Fade, Paper, Popper, responsiveFontSizes } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Widget from './Widget';

// Gerekli bileşenleri kaydedin
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];



const GridArea = ({ items, label, handleAddWidget, handleOpenRemoveWidget, openConfigure, dateShowValue, customDateValue, moveWidget }) => {
    const { t } = useTranslation();


    useEffect(() => {
        handleHeightGridContainer()
        window.addEventListener('resize', handleHeightGridContainer);

        return () => {
            window.removeEventListener('resize', handleHeightGridContainer);
        };
    }, [])

    const handleHeightGridContainer = () => {
        const gridContainer = document.querySelector(".db-widgets-grid-container")

        if (gridContainer) {
            const headerContainer = document.querySelector(".db-header-contatiner")?.offsetHeight
            if (headerContainer) {
                gridContainer.style.minHeight = `calc(100vh - (${headerContainer}px + 60px))`;
                gridContainer.style.maxHeight = `calc(100vh - (${headerContainer}px + 60px))`;
            }
        }
    }

    const fillMissingDates = (startDate, endDate, values) => {
        const date = new Date(startDate);
        const datesWithValues = new Set(values.map(item => item.date));
        const allDates = [];

        while (date <= endDate) {
            const dateString = date.toISOString().split('T')[0];
            if (!datesWithValues.has(dateString)) {
                allDates.push({ date: dateString, count: 0 });
            } else {
                allDates.push(values.find(item => item.date === dateString));
            }
            date.setDate(date.getDate() + 1);
        }

        return allDates;
    };
    const fillMonths = (values) => {
        const positions = [];
        const daysInWeek = 7;
        const cellWidth = 12; // Hücre genişliği (px cinsinden)
        const cellMargin = 2; // Hücreler arasındaki boşluk (px cinsinden)
        const totalCellSize = cellWidth + cellMargin;

        values.forEach((value, index) => {
            const date = new Date(value.date);
            const month = date.getMonth(); // 0 = Ocak, 1 = Şubat, vb.
            const dayOfWeek = date.getDay();

            // Haftanın ilk günü mü? O zaman pozisyonu kaydedelim
            if (dayOfWeek === 0) {
                const xOffset = Math.floor(index / daysInWeek) * totalCellSize;
                if (!positions.some(pos => pos.month === month)) {
                    positions.push({ month, xOffset });
                }
            }
        });
        return positions
    };

    // return (
    //     <div className="db-widgets-grid-container">
    //         {items.map((item, index) => (
    //             <div
    //                 key={index}
    //                 className="db-grid-item"
    //                 style={{
    //                     gridColumn: `span ${item.cols || 1}`,
    //                     gridRow: `span ${item.rows || 1}`,
    //                 }}
    //             >
    //                 {item.content}
    //             </div>
    //         ))}
    //     </div>
    // )
    return (
        <div className="db-widgets-grid-container">
            {items && items.length ? items.map((item, index) => {
                return <>
                    {/* <div
                        key={index}
                        className="db-grid-item"
                        style={{
                            gridColumn: `span ${item.cols || 1}`,
                            gridRow: `span ${item.rows || 1}`,
                        }}
                    > */}
                    {/* {handleFindWidget(item.content)} */}
                    <Widget key={item.id} item={item} handleAddWidget={handleAddWidget} handleOpenRemoveWidget={handleOpenRemoveWidget}
                        openConfigure={openConfigure} label={label} moveWidget={moveWidget} id={item.id} dateType={dateShowValue} customDate={customDateValue} />
                    {/* <MoreVertIcon className='db-grid-item-edit-button' onClick={handleClick} />
                        <Popper open={open} anchorEl={anchorEl} style={{ marginTop: 10, minWidth: 500, minHeight: 150 }} transition placement='bottom-start'>
                            {({ TransitionProps }) => (
                                <ClickAwayListener onClickAway={handleClose}>
                                    <Fade {...TransitionProps} timeout={350}>
                                        <Paper className='db-notification-popper'>
                                            <div onClick={() => handleAddWidget(item.content?.id, item.content?.order)}>Edit</div>
                                            <div>Delete</div>
                                        </Paper>
                                    </Fade>
                                </ClickAwayListener>
                            )
                            }
                        </Popper > */}
                    {/* <Bar data={item.content.data} options={verticalChartOptions} /> */}
                    {/* </div> */}
                </>
            }
            ) : <div
                className="db-grid-item db-add-available-grid"
                onClick={() => handleAddWidget()}
                style={{
                    gridColumn: `span ${4 || 1}`,
                    gridRow: `span ${3 || 1}`,
                }}
            >
                <div className='db-add-widget-container'>
                    <img className='db-add-widget-icon' src={AddWidgetIcon} />
                    <span className='db-add-widget-text'>{t(label + "ADD-WIDGET")}</span>
                </div>
            </div>
            }
            {items?.length ? <div
                className="db-grid-item db-add-available-grid"
                onClick={() => handleAddWidget()}
                style={{
                    gridColumn: `span ${1 || 1}`,
                    gridRow: `span ${1 || 1}`,
                }}
            >
                <div className='db-add-widget-container'>
                    <img className='db-add-widget-icon' src={AddWidgetIcon} />
                    <span className='db-add-widget-text'>{t(label + "ADD-WIDGET")}</span>
                </div>
            </div> : ""}
        </div >
    )
}

export default GridArea